/* eslint-disable import/no-named-as-default */
/* eslint-disable import/no-named-as-default-member */
import { all } from 'redux-saga/effects';

import auth from './auth/sagas';
import generalIndicator from './generalIndicators/sagas';
import indicators from './indicators/sagas';
import careLines from './careLines/sagas';
import instituitions from './instituitions/sagas';
import users from './users/sagas';
import comunicado from './comunicado/sagas';

export default function* rootSaga() {
  return yield all([
    auth,
    generalIndicator,
    indicators,
    careLines,
    instituitions,
    users,
    comunicado,
  ]);
}
